import { Box, Heading } from '@wix/design-system';
import { DomainText } from '@wix/domains-search-suite';
import { Block } from '@wix/wix-ui-icons-common/lazy';
import React from 'react';
import { useIsMobile } from '../../hooks/useIsMobile';
import heroCardStyles from '../HeroCard/HeroCard.css';
import { SearchedDomainBrokerDataHooks } from './dataHooks';
export const BrokerDomainTitle = _ref => {
  let domainName = _ref.domainName;
  const isMobile = useIsMobile();
  return /*#__PURE__*/React.createElement(Box, {
    verticalAlign: "middle",
    gap: isMobile ? '4px' : '2px',
    minWidth: 0
  }, /*#__PURE__*/React.createElement(Box, {
    color: "D40",
    flexShrink: 0
  }, /*#__PURE__*/React.createElement(Block, {
    size: "28px"
  })), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    flex: 1,
    minWidth: 0,
    className: heroCardStyles.titleColumn
  }, /*#__PURE__*/React.createElement(DomainText, {
    overflowStrategy: "scale",
    minFontSize: "1.25rem",
    maxFontSize: "1.75rem",
    maxWidth: isMobile ? '310px' : '440px',
    textComponent: Heading,
    textComponentProps: {
      size: isMobile ? 'large' : 'extraLarge',
      as: 'h2'
    },
    className: heroCardStyles.scaledCompactDomain,
    dataHook: SearchedDomainBrokerDataHooks.domain
  }, domainName)));
};
//# sourceMappingURL=BrokerDomainTitle.js.map